import { useState } from 'react';
import { useDispatch } from 'react-redux';
const Footer = () => {
  const role = localStorage.getItem("roles");
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");

  if (role && role !== "Student") return null;

  return (
    <>
      {/* Footer */}
      <footer className="footer">
        
        
        <div className="footer-bottom">
          <div className="container">
            <div className="row row-gap-2">
              <div className="col-md-6">
                <div className="text-center text-md-start">
                  <p className="text-white">Copyright © 2025 AIATI. All rights reserved.</p>
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
